module.exports = __webpack_public_path__ + "static/media/nucleo-icons.48ac036d.ttf";